module.exports = __webpack_public_path__ + "static/img/big_border2.af7ba185.png";